import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {Map} from "immutable";
import {ProgressBar} from "@blueprintjs/core";
import Modal from "@atlaskit/modal-dialog/dist/esm/components/Modal";

// Components
import ProjectDetail from "./ProjectDetail";
import ProjectMaterials from "./ProjectMaterials";
import ProjectWorkReports from './ProjectWorkReports';
import ProjectProblems from "./ProjectProblems";
import ProjectFiles from "./ProjectFiles";
import DeleteDialog from '../../components/dialogs/DeleteDialog';

// Actions
import {
    getProject,
    updateProject,
    changeProjectStatus,
    registerProblem,
    deleteProblem,
    uploadProjectFiles,
    downloadProjectFile,
    deleteProjectFile,
    deleteProject,
    cleanProjects
} from "../../actions/projects";
import {addNotification} from "../../actions/notifications";
import ProjectPurchaseOrders from './ProjectPurchaseOrders';

class ProjectTabs extends Component {

    // Component lifecycle
    constructor(props) {
        super(props);

        this.state = {
            tabIndex: this.getSelectedIndex(),
            mode: 'view',
            canSubmit: false,
            // modal
            modalIsOpen: false,
            modalType: null
        };

        this.getSelectedIndex = this.getSelectedIndex.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }
    componentDidMount() {
        this.props.getProject(this.props.match.params.projectId);
    }
    componentWillUnmount() {
        this.props.cleanProjects();
    }

    // Tab functions
    getSelectedIndex() {
        const {projectId} = this.props.match.params;

        // Check if any child route is active. As last step, check if principal route is active to assign default tab index.
        switch (this.props.history.location.pathname) {
            case '/proyectos/' + projectId + '/detalle':
                return 0;
            case '/proyectos/' + projectId + '/materiales':
                return 1;
            case '/proyectos/' + projectId + '/registro':
                return 2;
            case '/proyectos/' + projectId + '/incidencias':
                return 3;
            case '/proyectos/' + projectId + '/ficheros':
                return 4;
            case '/proyectos/' + projectId + '/pedidos':
                return 5;
            default:
                return 0;
        }
    }
    handleTabChange(index, lastIndex, event) {
        const {projectId} = this.props.match.params;
        let route = '';

        switch (index) {
            case 0:
                route = '/proyectos/' + projectId + '/detalle';
                break;
            case 1:
                route = '/proyectos/' + projectId + '/materiales';
                break;
            case 2:
                route = '/proyectos/' + projectId + '/registro';
                break;
            case 3:
                route = '/proyectos/' + projectId + '/incidencias';
                break;
            case 4:
                route = '/proyectos/' + projectId + '/ficheros';
                break;
            case 5:
                route = '/proyectos/' + projectId + '/pedidos';
                break;
            default:
                break;
        }

        this.props.history.push(route);
        this.setState({
            tabIndex: this.getSelectedIndex()
        });
    }

    // ProjectTabs & ProjectDetail
    handleEditClick = () => {
        this.setState({
            mode: 'edit'
        });
    };
    handleCancelClick = () => {
        this.child.setProjectState();
        this.setState({
            mode: 'view',
            canSubmit: false
        });
    };
    handleSaveClick = () => {
        this.child.updateProject();
        this.setState({
            mode: 'view',
            canSubmit: false
        });
    };
    canSubmit = (canSubmit) => {
        this.setState({ canSubmit })
    };

    // ProjectProblems
    onRegisterProblem = (problem) => {
        this.props.registerProblem(this.props.match.params.projectId, problem);
    };
    onDeleteProblem = (problemId) => {
        this.props.deleteProblem(this.props.match.params.projectId, problemId);
    };

    // Modal handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {
        this.setState({
            modalType: null,
            modalIsOpen: false
        })
    };

    render() {
        const { tabIndex, mode, canSubmit } = this.state;

        // Modal Area
        let modal = null;
        if (this.state.modalIsOpen) {
            switch (this.state.modalType) {
                case 'deleteDialog':
                    modal = {
                        width: 'medium',
                        title: 'Borrar proyecto',
                        body: (
                            <DeleteDialog
                                text={ this.props.project.get('project_code') }
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="delete"
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={ () => {
                                        this.props.deleteProject(this.props.project.get('_id'));
                                        this.closeModal();
                                        this.props.history.push('/proyectos');
                                    }}
                                >
                                    {'Borrar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-auto d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/proyectos">Proyectos</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>{`[${this.props.project.get('project_code') || ''}] ${this.props.project.get('name') || ''}`}</strong>
                            </li>
                        </ol>
                    </div>
                    { this.props.uploadProgress.get('isUploading')
                        ? <div className="col d-flex align-items-center justify-content-end">
                            <ProgressBar
                                intent="PRIMARY"
                                value={ this.props.uploadProgress.get('percent') } />
                        </div>
                        : null
                    }
                    { tabIndex === 0
                        ? (
                            <div className="col d-flex align-items-center justify-content-end">
                                {mode === 'view'
                                    ? <div className="title-action">
                                        { this.props.project.get('can_delete')
                                            ? <button className="btn btn-danger" onClick={ () => this.openModal('deleteDialog') }>Borrar</button>
                                            : null
                                        }
                                        <button className="btn btn-custom" onClick={this.handleEditClick}>Editar</button>
                                    </div>
                                    : <div className="title-action">
                                        <button className="btn btn-cancel" onClick={this.handleCancelClick}>Cancelar</button>
                                        <button
                                            className="btn btn-primary"
                                            onClick={this.handleSaveClick}
                                            disabled={!canSubmit}
                                        >Guardar
                                        </button>
                                    </div>
                                }
                            </div>
                        ) : ''
                    }
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="tabs-container">
                                <Tabs
                                    selectedIndex={tabIndex}
                                    onSelect={this.handleTabChange}
                                    selectedTabPanelClassName="active show"
                                >
                                    <TabList className="nav nav-tabs">
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 0})}>Detalle</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 1})}>Materiales</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 2})}>Registros de trabajo</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 3})}>Incidencias</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 4})}>Ficheros</Link>
                                        </Tab>
                                        <Tab>
                                            <Link to="#"
                                                  className={'nav-link ' + classnames({'active show': tabIndex === 5})}>Pedidos</Link>
                                        </Tab>
                                    </TabList>
                                    <div className="tab-content">
                                        <TabPanel className="tab-pane">
                                            { this.props.project.get('_id')
                                                ? <ProjectDetail
                                                    onRef={ref => (this.child = ref)}
                                                    mode={this.state.mode}
                                                    project={this.props.project}
                                                    updateProject={this.props.updateProject}
                                                    changeProjectStatus={this.props.changeProjectStatus}
                                                    canSubmit={this.canSubmit}
                                                />
                                                : null
                                            }

                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            { this.props.project.get('_id')
                                                ? <ProjectMaterials
                                                    project={this.props.project}
                                                />
                                                : null
                                            }
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            { this.props.project.get('_id')
                                                ? <ProjectWorkReports
                                                    project={this.props.project}
                                                />
                                                : null
                                            }
                                        </TabPanel>
                                        <TabPanel className="tab-pane">
                                            { this.props.project.get('_id')
                                                ? <ProjectProblems
                                                    project={this.props.project}
                                                    onRegisterProblem={this.onRegisterProblem}
                                                    onDeleteProblem={this.onDeleteProblem}
                                                />
                                                : null
                                            }
                                        </TabPanel>
                                        <TabPanel className="tab-pane" >
                                            { this.props.project.get('_id')
                                                ? <ProjectFiles
                                                    project={this.props.project}
                                                    uploadProjectFiles={this.props.uploadProjectFiles}
                                                    uploadProgress={this.props.uploadProgress}
                                                    downloadProjectFile={this.props.downloadProjectFile}
                                                    deleteProjectFile={this.props.deleteProjectFile}
                                                    addNotification={this.props.addNotification}
                                                />
                                                : null
                                            }
                                        </TabPanel>
                                        <TabPanel className="tab-pane" >
                                            { this.props.project.get('_id')
                                                ? <ProjectPurchaseOrders 
                                                    project={this.props.project}
                                                    updateProject={this.props.updateProject}
                                                />
                                                : null
                                            }
                                        </TabPanel>
                                    </div>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
                { this.state.modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    // Reducers
    const projectReducer = state.projects;

    // Project
    const project = projectReducer.get('payload') || Map({});

    // Upload Progress
    const uploadProgress = Map({
        isUploading: projectReducer.get('isUploading') || false,
        percent: projectReducer.get('percent') || 0
    });

    return {
        project,
        uploadProgress
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProject: (projectId) => dispatch(getProject(projectId)),
        updateProject: (projectId, project) => dispatch(updateProject(projectId, project)),
        changeProjectStatus: (projectId, status) => dispatch(changeProjectStatus(projectId, status)),
        registerProblem: (projectId, problem) => dispatch(registerProblem(projectId, problem)),
        deleteProblem: (projectId, problemId) => dispatch(deleteProblem(projectId, problemId)),
        uploadProjectFiles: (projectId, files) => dispatch(uploadProjectFiles(projectId, files)),
        downloadProjectFile: (projectId, fileId) => dispatch(downloadProjectFile(projectId, fileId)),
        deleteProjectFile: (projectId, fileId) => dispatch(deleteProjectFile(projectId, fileId)),
        deleteProject: projectId => dispatch(deleteProject(projectId)),
        cleanProjects: () => dispatch(cleanProjects()),
        addNotification: (notification) => dispatch(addNotification(notification))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectTabs);



// WEBPACK FOOTER //
// ./src/containers/projects/ProjectTabs.js